import { Component, Input, inject } from '@angular/core';
import { LoggerService } from '../../services/logger.service';

@Component({
    standalone: false,
    selector: 'por-cp-demo',
    templateUrl: './cp-demo.component.html',
    styleUrls: ['./cp-demo.component.scss']
})
export class CpDemoComponent {
    private readonly logger = inject(LoggerService);

    @Input() url = '';
    @Input() config = '';

    handleOutPutError($e: any) {
        this.logger.logInfo({
            $e
        });
    }
}
